import { Divider, Button,  } from "antd"
import { useEffect, useState } from "react"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"

import Title from "components/Title"

import HelpDeskForm from './form';
import List from "./list"

const HelpDeskModal = (props) => {
  const [currentView, setCurrentView] = useState('list')

  useEffect(() => {
    fetchData()    
  }, []) // eslint-disable-line

  const fetchData = async () => {
    try {
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div style={{ padding: 10 }}>
      <Title size={18}>Support</Title>
      <Divider />

      {
        currentView === 'list' && (
          <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
            <Button onClick={() => setCurrentView('form')} type="link" style={{ margin: 0, padding: 0, textDecoration: 'underline'}}>Un problème avec une commande ?</Button>
          </div>
        )
      }

      {
        currentView === 'list' ? (
          <List />
        ) : (
          <HelpDeskForm 
            handleOnCancelFormView={() => setCurrentView('list')}
          />
        )
      }
    </div>
  )
}

const stateToProps = state => ({
  auth: state.auth
})

export default connect(stateToProps)(withTranslation()(HelpDeskModal))